import { Box, Container, Grid, Typography, Card } from "@mui/material";
import SpeedIcon from "@mui/icons-material/Speed";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import GroupsIcon from "@mui/icons-material/Groups";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";

const whyItems = [
  {
    icon: <SpeedIcon />,
    title: "Faster Delivery",
    desc: "Agile SAP implementation and support approach to reduce delays and improve project execution.",
  },
  {
    icon: <VerifiedUserIcon />,
    title: "Reliable Expertise",
    desc: "Experienced SAP consultants delivering secure, scalable, and business-focused solutions.",
  },
  {
    icon: <GroupsIcon />,
    title: "Client-Focused Team",
    desc: "We work closely with your teams to understand operations, challenges, and growth objectives.",
  },
  {
    icon: <AutoFixHighIcon />,
    title: "Smart Optimization",
    desc: "We improve workflows, automate processes, and modernize systems for better performance.",
  },
];

export default function WhySection() {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        overflow: "hidden",
        py: { xs: 8, md: 12 },
        background: "#071525",
        color: "#fff",

        "&::before": {
          content: '""',
          position: "absolute",
          width: 420,
          height: 420,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0,200,83,0.22), transparent 65%)",
          top: -150,
          right: -120,
        },

        "&::after": {
          content: '""',
          position: "absolute",
          width: 360,
          height: 360,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(62,23,255,0.25), transparent 65%)",
          bottom: -130,
          left: -100,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <Box sx={{ maxWidth: 700, mb: 6, textAlign: "center", mx: "auto" }}>
          <Box
            sx={{
              width: 120,
              height: 5,
              borderRadius: 10,
              mb: 3,
              background: "linear-gradient(90deg, #00c853, #5b35ff)",
            }}
          />

          <Typography
            variant="h2"
            sx={{
              fontWeight: 850,
              fontSize: { xs: "2rem", sm: "2.4rem", md: "3rem" },
              lineHeight: 1.1,
              mb: 2,
            }}
          >
            Why Choose{" "}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(90deg, #00c853, #5b35ff)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Zencon?
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.72)",
              fontSize: { xs: "0.8rem", md: "1rem" },
              lineHeight: 1.8,
            }}
          >
            We help businesses modernize SAP systems, improve operations, and
            build smarter digital processes with reliable technical delivery.
          </Typography>
        </Box>

        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {whyItems.map((item, index) => (
            <Grid size={{ xs: 12, md: 6 }} key={index}>
              <Card
                sx={{
                  height: "100%",
                  p: 3,
                  borderRadius: 5,
                  background: "rgba(255,255,255,0.07)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  boxShadow: "none",
                  backdropFilter: "blur(16px)",
                  transition: "all 0.35s ease",
                  animation: `whyFloat ${5 + index * 0.4}s ease-in-out infinite`,

                  "&:hover": {
                    transform: "translateY(-8px)",
                    background: "rgba(255,255,255,0.11)",
                    borderColor: "rgba(0,200,83,0.5)",
                  },

                  "@keyframes whyFloat": {
                    "0%, 100%": { transform: "translateY(0)" },
                    "50%": { transform: "translateY(-10px)" },
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 58,
                      height: 58,
                      borderRadius: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#00c853",
                      background: "rgba(0,200,83,0.12)",

                      "& svg": {
                        fontSize: 30,
                      },
                    }}
                  >
                    {item.icon}
                  </Box>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.25rem" },
                      fontWeight: 750,
                      color: "#fff",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.68)",
                    lineHeight: 1.7,
                    fontSize: { xs: "0.8rem", md: "1rem" },
                  }}
                >
                  {item.desc}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
